import { useLocation, useHistory } from 'react-router-dom';
import { useCallback } from 'react';

export function useNavigate() {
    const history = useHistory();
    const location = useLocation();

    const navigate = useCallback(
        (pathname: string, search?: string | null, state?: any) => {
            if (search === null || typeof search === 'undefined') {
                history.push(pathname, state);
            } else if (typeof search === 'undefined') {
                history.push({ pathname, search: location.search }, state);
            } else {
                history.push({ pathname, search }, state);
            }
        },
        [history, location.search]
    );

    return navigate;
}
